import { registerQuery, registerMutation } from 'data-fetching-client';
import enviro from 'enviro';
import apiClient from 'hub-http/clients/apiClient';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getUserIdsOnHubByRoleIdAndPendingStatusRpc } from '../../../__generated__/chirp/com/hubspot/appusers/rpc/UsersRpc';
import { searchRpc } from '../../../__generated__/chirp/com/hubspot/userssearch/rpc/AppUsersSearch';
const chirpClient = createRpcClientV2({
  hubHttpClient: apiClient
});
export const SUPER_ADMIN_ROLE_ID = enviro.isProd() ? 153 : 40436;
export const USERS_SEARCH_MAX_PAGE_LENGTH = 500;
const chunk = (items, size) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};
const toAdminUser = user => ({
  id: user.userId,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  pending: !user.confirmed
});
export const fetchAdmins = async () => {
  const {
    userIds = []
  } = await chirpClient.call(getUserIdsOnHubByRoleIdAndPendingStatusRpc, {
    request: {
      roleId: SUPER_ADMIN_ROLE_ID,
      includePending: true,
      includeInactive: false
    }
  });
  if (userIds.length === 0) {
    return [];
  }
  const responses = await Promise.all(chunk(userIds, USERS_SEARCH_MAX_PAGE_LENGTH).map(batch => chirpClient.call(searchRpc, {
    request: {
      mustMatchUserIds: batch,
      pageLength: batch.length,
      onlyConfirmedUsers: false,
      includeDeactivatedUsers: false
    }
  })));
  return responses.flatMap(({
    results = []
  }) => results.map(toAdminUser));
};
export const GET_ADMINS = registerQuery({
  fieldName: 'admins',
  args: [],
  fetcher: async () => {
    try {
      return await fetchAdmins();
    } catch (error) {
      console.error('Error fetching admins:', error);
      throw error;
    }
  }
});
export const SEND_ADMIN_EMAIL = registerMutation({
  fieldName: 'sendAdminEmail',
  args: ['adminUserId', 'listingId', 'adminInstall', 'permissions'],
  fetcher: async ({
    adminUserId,
    listingId,
    adminInstall = false,
    permissions = []
  }) => {
    const ecosystemClient = getEcosystemClient('app');
    const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
    const data = adminInstall ? {
      adminUserId,
      listingId
    } : {
      adminUserId,
      listingId,
      permissions
    };
    try {
      await ecosystemClient.post(endpoint, {
        data
      });
      return {
        success: true
      };
    } catch (error) {
      console.error('Error sending admin email:', error);
      throw error;
    }
  }
});

// Legacy wrapper function for backward compatibility
export const sendAdminEmail = async (adminUserId, listingId, adminInstall = false, permissions = []) => {
  const ecosystemClient = getEcosystemClient('app');
  const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
  const data = adminInstall ? {
    adminUserId,
    listingId
  } : {
    adminUserId,
    listingId,
    permissions
  };
  try {
    await ecosystemClient.post(endpoint, {
      data
    });
  } catch (error) {
    console.error('Error sending admin email:', error);
    throw error;
  }
};